// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__68u87","top":"styles_top__1k4bL","left":"styles_left__2b8pw","description":"styles_description__20H12"};